<div mat-icon-button class="close-button" [mat-dialog-close]="true">
  <img class="float-end" src="assets/img/circle_images/delete.png" width="30" />
</div>
<div *ngIf="dealerUsers != null" class="container-fluid">
  <div class="mat-dialog-title">
    <h3>{{dealerName}} Users</h3>
  </div>
  <div>To change the status of a user, click the toggle to activate/deactivate the user.</div>
  <div class="card bg-light">
      <div class="card-body">
          <div class="form-inline mt-2 mb-2">
              <input id="searchText" name="searchText" class="form-control mr-sm-2" [(ngModel)]="searchText">
              <button class="btn btn-bidit-action btn-sm" (click)="searchDealerUsers()" type="submit">Apply Filter</button>
          </div>
          <mat-table class="table table-bidit table-hover" [dataSource]="dataSource"
                     matSort matSortActive="lastName" matSortDirection="asc">
              <ng-container matColumnDef="lastName">
                  <mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>User Name</mat-header-cell>
                  <mat-cell *matCellDef="let user">
                      {{user.lastName}}, {{user.firstName}}
                  </mat-cell>
              </ng-container>
              <ng-container matColumnDef="email">
                  <mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>Email</mat-header-cell>
                  <mat-cell *matCellDef="let user">
                      {{user.email}}
                  </mat-cell>
              </ng-container>
              <ng-container matColumnDef="phoneNumber">
                  <mat-header-cell *matHeaderCellDef mat-sort-header class="bidit-header" i18n>Phone Number</mat-header-cell>
                  <mat-cell *matCellDef="let user">
                      {{user.phoneNumber}}
                  </mat-cell>
              </ng-container>
              <ng-container matColumnDef="action">
                  <mat-header-cell *matHeaderCellDef class="bidit-header" i18n></mat-header-cell>
                  <mat-cell *matCellDef="let user">
                      <div class="form-inline">
                          <label id="user_status_active{{user.id}}" [ngClass]="{'text-success' : user.isActive}">active</label>
                          <input (change)="toggleUserStatus(user.id)" type="checkbox" name="user_status_{{user.id}}" id="user_status_{{user.id}}" class="bidit-switch-sm ml-1 mr-1" [ngModel]="!user.isActive" (ngModelChange)="user.isActive = $event">
                          <label id="user_status_inactive{{user.id}}" [ngClass]="{'text-danger' : !user.isActive}">inactive</label>
                      </div>
                  </mat-cell>
              </ng-container>

              <mat-header-row *matHeaderRowDef="displayedColumns">
              </mat-header-row>
              <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
          </mat-table>

          <mat-paginator [length]="dealerUsers?.length" [pageSize]="25" [pageSizeOptions]="[25]"></mat-paginator>
      </div>
  </div>
</div>
